module.exports = __webpack_public_path__ + "static/media/customer-allana.7d7de91a.png";